// import { useGetAirQuality } from './useGetAirQuality';
import { useGetAlertsHeadlines } from './useGetAlertsHeadlines/useGetAlertsHeadlines';
import { useGetANFAlerts } from './useGetANFAlerts';
import { useGetCurrentLocationWeather } from './useGetCurrentLocationWeather';
import { useGetDailyForecast } from './useGetDailyForecast';
import { useGetHourlyForecast } from './useGetHourlyForecast';
import { useGetLiveVideo } from './useGetLiveVideo';
import { useGetMediaTailorAdInfo } from './useGetMediaTailorAdInfo';
import { useGetOnboardingLanding } from './useGetOnboardingLanding';
import { useGetOnboardingPlans } from './useGetOnboardingPlans';
import { useGetPollenIndex } from './useGetPollenIndex';
import { useGetVODLanding } from './useGetVODLanding';

export const useTWCApi = () => {
  useGetAlertsHeadlines();
  useGetCurrentLocationWeather();
  // useGetAirQuality();
  useGetDailyForecast();
  useGetHourlyForecast();
  useGetOnboardingLanding();
  useGetOnboardingPlans();
  useGetPollenIndex();
  useGetVODLanding();
  useGetLiveVideo();
  useGetMediaTailorAdInfo();
  useGetANFAlerts();
};
